import { register } from 'swiper/element';

export default defineNuxtPlugin((nuxtApp) => {
  register();
});